import { render } from "./suspendLicenseModal.vue?vue&type=template&id=f3eb3d06"
import script from "./suspendLicenseModal.vue?vue&type=script&lang=js"
export * from "./suspendLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__